module.exports = __webpack_public_path__ + "assets/img/ranking.ce729d35.png";